import * as React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';

import { Dialog, DialogActions, DialogContent, DialogTitle } from 'components';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useActivateZoneMutation } from 'store/apis';

interface ZoneActivateDialogProps {
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  zoneId: number;
}

export const ZoneActivateDialog = ({ visible = false, setVisible = () => {}, zoneId }: ZoneActivateDialogProps) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const [activateZone, { isLoading: loading_activate, isSuccess: success_activate, isError: error_activate }] =
    useActivateZoneMutation();

  React.useEffect(() => {
    if (!loading_activate && success_activate && !error_activate) {
      setVisible(false);
    }
  }, [loading_activate, success_activate, error_activate]);

  const onClose = (event: any, reason: string) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setVisible(false);
      document.body.removeAttribute('style');
    }
  };

  const onConfirm = () => {
    activateZone({ orgSlug, id: zoneId });
  };

  return (
    <Dialog onClose={onClose} open={visible} fullScreen={false}>
      <DialogTitle>
        <Typography variant="h6" component="span">
          Confirm activate zone
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box>
          <Typography variant="subtitle2" color="textSecondary">
            This zone will be added to your cart. To finish activating this zone, go to the checkout page and confirm
            changes to your subscription.
          </Typography>
          <Typography variant="subtitle2" color="textSecondary">
            Would you like to continue?
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={() => onClose(null, 'anyway')}
          sx={{
            paddingX: 2,
            color: (theme) => theme.palette.text.secondary,
          }}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          onClick={onConfirm}
          disabled={loading_activate}
          endIcon={loading_activate && <CircularProgress color="inherit" size={14} />}
          sx={{
            paddingX: 2,
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
